import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';

import { ctw } from '@/common/utils/ctw/ctw';

export const AlertDescription = forwardRef<
  HTMLParagraphElement,
  HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={ctw('text-sm [&_p]:leading-relaxed', className)} {...props} />
));

AlertDescription.displayName = 'AlertDescription';
